import React from 'react';
import ContentLoader from '@adsk/alloy-react-content-loader';
const ResultsLoader = () => /*#__PURE__*/React.createElement(ContentLoader, {
  width: 100,
  height: 10,
  viewBox: "0 0 100 10"
}, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "3",
  rx: "3",
  ry: "3",
  width: "100",
  height: "6"
}));
ResultsLoader.displayName = 'ResultsLoader';
export default ResultsLoader;
//# sourceMappingURL=ResultsLoader.js.map